import { render, staticRenderFns } from "./MyClaimsSummaryChart.vue?vue&type=template&id=6aea27ec&"
import script from "./MyClaimsSummaryChart.vue?vue&type=script&lang=js&"
export * from "./MyClaimsSummaryChart.vue?vue&type=script&lang=js&"
import style0 from "./MyClaimsSummaryChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports